import React from "react";
import { UrlProvider } from "../../../utils/UrlProvider";

const EachFeature = ({ feature }) => {
  return (
    <div
      className=" bg-[#FFFFFF] text-center mx-[0.6vw] md:rounded-[1vw] rounded-[5vw] md:py-[1.5vw] py-[5vw]"
    >
      <img
        src={UrlProvider(feature?.icon?.url)}
        alt={feature?.icon?.alternativeText}
        className="block m-auto"
      />
      <div className="w-[80%] md:w-[75%] m-auto md:my-[0.5vw] my-[2.5vw] text-[4vw] md:text-[1.3vw] font-[600] font-krubBold leading-tight">
        <p style={{ color: feature?.feature_title_color }}>
          {feature?.feature_title}
        </p>
      </div>
      <div className="w-[78%] md:w-[75%] m-auto leading-tight text-[3vw] md:text-[0.9vw] font-krubMedium">
        <p style={{ color: feature?.feature_description_color }}>
          {feature?.feature_description}
        </p>
      </div>
    </div>
  );
};

export default EachFeature;
